type EmptyResultProps = {
  text: string;
};

const EmptyResult = ({text}: EmptyResultProps) => {
  return (
    <div>
      <div className="grid justify-center py-5">
        <img alt="" className="dark:hidden max-h-[170px]" src="media/illustrations/11.svg"/>
        <img alt="" className="light:hidden max-h-[170px]" src="media/illustrations/11-dark.svg"/>
      </div>
      <div className="text-lg font-medium text-sky-700	text-center">
        {text}
      </div>
    </div>
  );
}

export default EmptyResult;